import Confirm from 'assets/components/page/templates/Confirm';
import ThemeConfirmDefault from 'assets/components/page/templates/themes/Theme.Confirm.Default';
import { getLocales } from 'assets/locales/Locale';
import React from 'react';
import { useVehicleMakeProvider } from '../VehicleMake.Hooks';

export default function VehicleMakeDelete() {
  const { lang } = getLocales();
  const { deleteApi, selected, pageRouter } = useVehicleMakeProvider();

  return (
    <Confirm
      data={selected}
      onConfirm={({ id }) => deleteApi.execute(id)}
      onClose={pageRouter.updateParams}
      actionName={lang.delete}
      itemName={selected.makeCode}
      confirmationType="nextButton"
      subcomponents={ThemeConfirmDefault}
    />
  );
}
